<template>
    <div class="news-detail-container">
        <div class="breadcrumb">
            <router-link class="link" :to="{ name: 'home' }">首页</router-link>
            <span class="separator">/</span>
            <span class="text">{{ breadName }}</span>
        </div>
        <div class="news-content" v-loading="loading">
            <div class="header" v-html="data?.contentTitle || ''"></div>
            <div class="date">
                <template v-if="route.name === 'noticeDetail' && data?.tag">
                    <span class="tag">{{ data?.tag }}</span>
                    <el-divider direction="vertical" class="v-divider-wrap"></el-divider>
                </template>
                <span>{{
                    data?.publishTime ? dayjs(data.publishTime).format('YYYY.MM.DD HH:mm:ss') : ''
                }}</span>
            </div>
            <div class="content">
                <EditorView
                    v-if="data.contentForm === 2"
                    :content="data.content"
                    :file-list="data.form2ResourceList"
                />
                <FileView v-if="data.contentForm === 3" :file-data="curFile" />
            </div>
        </div>
    </div>
</template>

<script setup>
import EditorView from './part/editor-view.vue';
import FileView from './part/file-view.vue';
import { ref, reactive, onMounted, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import dayjs from 'dayjs';

const store = useStore();

const route = useRoute();

const loading = ref(true);

let data = reactive({
    contentTitle: '', // 标题名称
    contentForm: '', // 1 链接 2 手动编辑 3 无内容
    clickUrl: '', // 跳转链接
    content: '', // 手动编辑内容
    publishTime: '', // 发布时间
    form2ResourceList: [], // 手动编辑的附件
    form3Resource: [], // 文件上传的附件
});

const curFile = computed(() => {
    return data?.form3Resource?.[0] || {};
});

// 全部备案信息
const brand = computed(() => {
    return store.state.brand || {};
});

const brandKey = computed(() => {
    return brand.value?.publishBrand?.brand || '';
});

const breadName = computed(() => {
    return route.name === 'informationDetail'
        ? brandKey.value === 'desjyj'
            ? '教科研动态'
            : '新闻'
        : route.name === 'bannerDetail'
        ? 'banner'
        : '公告';
});

const getContentDetail = () => {
    if (!route.query.id) {
        return false;
    }
    loading.value = true;
    G_transmit('getContentById', {
        name: 'getContentById',
        queries: {
            id: route.query.id,
        },
    })
        .then(res => {
            let result = res.data || {};
            Object.assign(data, result);
        })
        .finally(() => {
            loading.value = false;
        });
};

onMounted(() => {
    getContentDetail();
});
</script>

<style lang="scss" scoped>
.news-detail-container {
    width: 100%;
    .breadcrumb {
        font-size: 14px;
        margin-bottom: 23px;
        .link {
            color: var(--srt-breadcrumb-text-color);
            &:hover {
                color: var(--srt-breadcrumb-hover-text-color);
            }
        }
        .separator {
            margin: 0 6px;
            color: var(--srt-color-gray);
        }
        .text {
            color: var(--srt-breadcrumb-disabled-text-color);
        }
    }
    .news-content {
        background: var(--srt-color-white);
        border-radius: 4px;
        padding: 50px;
        min-height: 400px;
        .header {
            font-size: 28px;
            color: var(--srt-main-text-color);
            line-height: 37px;
            text-align: center;
            white-space: pre-wrap;
        }
        .date {
            font-size: 14px;
            line-height: 18px;
            color: var(--srt-color-gray);
            margin: 8px 0 28px 0;
            .tag {
                color: #2d7a34;
                background: #f0f9f0;
                padding: 0 4px;
                border-radius: 3px;
            }
            .v-divider-wrap {
                height: 16px;
                border-left: 1px solid #cccccc;
                margin: -2px 10px 0;
            }
        }
        .content {
            border-top: 1px solid #e0e2e4;
            padding-top: 30px;
        }
    }
}
</style>
